// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1vwov","exit":"Modal_exit__3EkQt","modal-card":"Modal_modal-card__2NwY8"};